import React from 'react';

const Loading = ({ message = 'Loading...', theme }) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '200px',
      fontSize: '18px',
      color: theme.text,
      backgroundColor: theme.cardBackground,
      borderRadius: '16px',
      boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
      border: `2px solid ${theme.secondary}`,
      padding: '40px',
      margin: '20px 0',
      transition: 'all 0.3s ease'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: `4px solid ${theme.optionBackground}`,
        borderTop: `4px solid ${theme.primary}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '20px'
      }}></div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <span style={{ fontWeight: '600' }}>{message}</span>
    </div>
  );
};

export default Loading;
